import { versionedHttpCollection } from "us.helper/http/collection";

export default {
  delay: {
    save: (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.post(
            "arservice",
            "ars/casedelay",
            params,
            "v1"
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
